import { useTranslations } from "use-intl";
import {
  FormControlLabel,
  RadioGroup,
  Radio,
  type RadioGroupProps,
} from "@mui/material";

import { TripType } from "@/app/lib/types/enums";

type Props = Required<Pick<RadioGroupProps, "value" | "onChange">>;

function TripTypeRadioGroup({ value, onChange }: Props) {
  const t = useTranslations();

  return (
    <RadioGroup
      row
      aria-label={t("flights.search.tripType")}
      name="tripType"
      className="mb-5 flex justify-center gap-4"
      value={value}
      onChange={onChange}
    >
      <FormControlLabel
        value={TripType.ONE_WAY}
        control={<Radio />}
        label={t("flights.search.oneWay")}
        sx={{
          m: 0,
          "& .MuiTypography-root": {
            fontSize: 14,
          },
        }}
      />
      <FormControlLabel
        value={TripType.ROUND_TRIP}
        control={<Radio />}
        label={t("flights.search.roundTrip")}
        sx={{
          m: 0,
          "& .MuiTypography-root": {
            fontSize: 14,
          },
        }}
      />
    </RadioGroup>
  );
}

export default TripTypeRadioGroup;
